import { axiosInstance } from '../../../App';
import {
  ActivityTypeDTO,
  ScoreTemplateOptionDTO,
  ProfessionalWithSpecialitiesDTO,
  LocationDTO,
  CurrentProfessionalDTO,
  PatientScheduledValidation,
  OverlapValidation,
  SpontaneousBookRequest,
  SpontaneousBookResponse,
} from '../types/spontaneous.types';

const BASE_URL = '/api/secured/agenda';

// ─── Combo data ───────────────────────────────────

export function getActivityTypes(): Promise<ActivityTypeDTO[]> {
  return axiosInstance.get<ActivityTypeDTO[]>(`${BASE_URL}/outofschedule/activity-types`)
    .then((r) => r.data);
}

export function getScoreTemplates(): Promise<ScoreTemplateOptionDTO[]> {
  return axiosInstance.get<ScoreTemplateOptionDTO[]>(`${BASE_URL}/outofschedule/score-templates`)
    .then((r) => r.data);
}

export function searchProfessionals(filter?: string): Promise<ProfessionalWithSpecialitiesDTO[]> {
  return axiosInstance.get<ProfessionalWithSpecialitiesDTO[]>(`${BASE_URL}/outofschedule/professionals`, {
    params: filter ? { filter } : {},
  }).then((r) => r.data);
}

export function getLocations(buildingId?: number | null): Promise<LocationDTO[]> {
  return axiosInstance.get<LocationDTO[]>(`${BASE_URL}/outofschedule/locations`, {
    params: buildingId ? { buildingId } : {},
  }).then((r) => r.data);
}

export function getCurrentProfessional(): Promise<CurrentProfessionalDTO | null> {
  return axiosInstance.get<CurrentProfessionalDTO>(`${BASE_URL}/me/professional`)
    .then((r) => r.data)
    .catch((err) => {
      if (err?.response?.status === 204) return null;
      throw err;
    });
}

// ─── Validations (step 2 → 3) ─────────────────────

export function validatePatientScheduled(
  professionalIds: number[],
  patientId: number,
  date: string,
): Promise<PatientScheduledValidation> {
  return axiosInstance.get<PatientScheduledValidation>(`${BASE_URL}/outofschedule/validate/patient-scheduled`, {
    params: { professionalIds: professionalIds.join(','), patientId, date },
  }).then((r) => r.data);
}

export function validateLocationOverlaps(body: {
  appointmentDate: string;
  fromTime: string;
  duration: number;
  locationIds: number[];
}): Promise<OverlapValidation> {
  return axiosInstance.post<OverlapValidation>(`${BASE_URL}/outofschedule/validate/location-overlaps`, body)
    .then((r) => r.data);
}

export function validateProfessionalOverlaps(body: {
  appointmentDate: string;
  fromTime: string;
  duration: number;
  professionalIds: number[];
}): Promise<OverlapValidation> {
  return axiosInstance.post<OverlapValidation>(`${BASE_URL}/outofschedule/validate/professional-overlaps`, body)
    .then((r) => r.data);
}

// ─── Booking ──────────────────────────────────────

export function bookSpontaneous(request: SpontaneousBookRequest): Promise<SpontaneousBookResponse> {
  return axiosInstance.post<SpontaneousBookResponse>(`${BASE_URL}/outofschedule/book`, request)
    .then((r) => r.data);
}
